export default __webpack_public_path__ + "static/media/instagram.58019fbb.svg";